var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-4"},[_c('img',{staticClass:"h-8",attrs:{"src":"/images/kai-logo-vector.svg"}})])}]

export { render, staticRenderFns }